export default "__VITE_ASSET__BJOs9$Mf__"